import { computed } from "vue";
import { useStore } from "vuex";
import axios from "axios";

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

export function usePropertySync() {
  const store = useStore();
  const session = computed(() => store.getters.getUserSession);

  function authHeaders() {
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value?.token_api}`,
    };
  }

  function isEasyBrokerSuccess(response) {
    return (
      response.status === 200 &&
      Array.isArray(response.data) &&
      response.data[0]?.status === "success"
    );
  }

  async function syncWithPropiedades(propertyId, options = {}) {
    const { mode = "update", onSuccess, onError } = options;
    const isCreateMode = mode === "create";
    const url = isCreateMode
      ? `${API_BASE_URL}/properties/${propertyId}/sync-with-propiedades`
      : `${API_BASE_URL}/propertiesComUpdate/${propertyId}`;

    try {
      const response = await axios[isCreateMode ? "post" : "put"](
        url,
        {},
        { headers: authHeaders() }
      );
      if (response.status === 200) {
        console.log("success", "Sincronización con propiedades.com completada");
        if (typeof onSuccess === "function") onSuccess(response);
      } else {
        console.log("Error en sincronización de propiedades.com: ", response.status);
      }
    } catch (error) {
      console.error("Error al sincronizar con propiedades.com:", error);
      if (typeof onError === "function") onError(error);
    }
  }

  async function syncWithEasyBroker(propertyId, options = {}) {
    const { endpoint = "editar", onSuccess, onError } = options;
    const url = `${API_BASE_URL}/${endpoint}-easybroker/${propertyId}`;

    try {
      const response = await axios.post(url, {}, { headers: authHeaders() });

      if (isEasyBrokerSuccess(response)) {
        console.log("[SYNC SUCCESS]", response.data);
        if (typeof onSuccess === "function") onSuccess(response);
      } else {
        console.warn("[SYNC WARNING] Error en respuesta:", response.data);
      }
    } catch (error) {
      console.error("[ERROR SYNCING WITH EASYBROKER]", error.response);
      if (typeof onError === "function") onError(error);
    }
  }

  return {
    syncWithPropiedades,
    syncWithEasyBroker,
    isEasyBrokerSuccess,
  };
}
